const FileSize = (size) => {
  if (size === 0) return '0 Bytes';

  const kb = 1024;

  const sizes = ['bytes', 'kb', 'mb'];

  const i = parseInt(Math.floor(Math.log(size) / Math.log(kb)), 10);

  return `${(size / kb ** i).toFixed(1)} ${sizes[i]}`;
};

export const FileSizeNumber = (size) => {
  return (size / 1024 ** 2).toFixed(2);
};

export default FileSize;
